import lightGallery from 'lightgallery';
// Plugins
import lgThumbnail from 'lightgallery/plugins/thumbnail'
import lgVideo from 'lightgallery/plugins/video'


// Keep the last focused element here - to improve tab order when using lightbox
let lastFocused = null;

/*
* Lightbox / gallery
* Used for construkt embeds and galleries
*/

document.addEventListener("DOMContentLoaded", () => {
    const lightboxElements = document.querySelectorAll(".c-lightbox");
    const lightgalleryElements = document.querySelectorAll(".c-lightgallery");

    // Embedded media / videos
    lightboxElements.forEach((lightbox, index) => {
        lightbox.id = `video-${index}`;
        
        lightGallery(lightbox, {
            plugins: [lgVideo],
            download: false,
            counter: false,
            width: '90%',
            trapFocus: true,
            closable: true,
            closeOnTap: true,
            enableSwipe: false,
            resetScrollPosition: true,
            youTubePlayerParams: {
                modestbranding : 1
            },
            getCaptionFromTitleOrAlt: false,
            licenseKey: '7193FD74-868442F8-AFC59789-16D26BC0',
            mobileSettings: {
                controls: true,
                showCloseIcon: true,
                download: false,
            },
        });

        handleLightboxEvents(lightbox, true);
    });

    // Image galleries
    lightgalleryElements.forEach((lightgallery, index) => {
        lightgallery.id = `gallery-${index}`;
        lightGallery(lightgallery, {
            thumbnail: true,
            plugins: [lgThumbnail],
            selector: ".light-gallery-item",
            download: false,
            counter: false,
            width: '90%',
            licenseKey: '7193FD74-868442F8-AFC59789-16D26BC0',
            mobileSettings: {
                controls: true,
                showCloseIcon: true,
            }
        });

        handleLightboxEvents(lightgallery, false);
    });
});

/*
* Adds custom events when opening and closing lightgalleries
* @param element - Lightbox wrapper element used to initialise the plugin
*/
function handleLightboxEvents(element, isVideo) {
    // Save the focus position before opening the lightbox
    element.addEventListener('lgBeforeOpen', () => {
        lastFocused = element.querySelector(".c-col-embedded-media__cover-link, .light-gallery-item");

        if (isVideo) {
            window.addEventListener("keydown", handleLightboxKeydown);
        }
    });

    // Go back to the last point of focus when closing the lightbox
    element.addEventListener('lgBeforeClose', () => {   
        if (lastFocused) {
            lastFocused.focus();
            lastFocused = null;
        }

        if (isVideo) {
            window.removeEventListener("keydown", handleLightboxKeydown);
        }
    });

    // Fix accessibility issue with focus on the close button
    function handleLightboxKeydown(e) {
        if (e.key === "Tab") {
            if (e.target.classList.contains("lg-close")) {
                e.preventDefault();
                let video = e.target.closest(".lg-video-wrapper").querySelector(".lg-video-object");
                if (video) {
                    video.focus();
                }
            }
        }
    }
}